<app-info-page
  title="{{ component ? component.name : '' }}"
  [hasBorderBottom]="true"
  [links]="links"
  [isComponentOrProject]="'COMPONENT'"
  [breadcrumbs]="breadcrumbs"
>
  @if (costumButtom?.visible) {
  <button
    [class]="costumButtom.cssStyle"
    color="primary"
    mat-flat-button
    ngProjectAs="buttons"
    style="margin-right: 8px"
    (click)="costumButtom.action()"
  >
    {{ costumButtom.text }}
  </button>
  }

  <button
    style="margin-left: 8px"
    mat-flat-button
    class="btn-grey btn-edit"
    id="btn-edit-component"
    aria-label="Edit component"
    [routerLink]="['/components/edit']"
    [queryParams]="{
      solution: solutionSpace,
      id: component.id,
      origin: origin
    }"
    ngProjectAs="buttons"
  >
    <mat-icon class="icon-wide">settings</mat-icon>
    <span class="label-wide">Edit component</span>
    <span class="label-phone">Edit</span>
  </button>
</app-info-page>
